import { defineMessages } from 'react-intl-next';

const _default_1: {
	clearAllSelectedItemsButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	clearAllSelectedItemsButtonText: {
		id: 'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
		defaultMessage: 'Clear selection',
		description: 'Clicking this button will unselect all the selected items in the dropdown',
	},
});
export default _default_1;
